import Button from 'components/button/Button'
import Input from 'components/input/Input'
import { InputBox } from 'components/input/InputStyled'
// import Currencies from 'functions/currency/getCurrencySymbol'
import React from 'react'
import { ReactComponent as MinusSVG } from '../../../assets/svg/minusN.svg'
import { ReactComponent as PlusSVG } from '../../../assets/svg/plusN.svg'
import { StakeWrapper } from './elementStyled'

interface OPERATION_PROPS {
  colors: any
  audio: any
  makeMathOperation: any
  SFX: any
  gameInfo: any
  stake: any
  setnumber: any
  setInputStake: any
  handleNotification: any
  isZero: any
  active?: boolean
  length?: any
}

export default function Stake({
  colors,
  audio,
  makeMathOperation,
  SFX,
  gameInfo,
  stake,
  setnumber,
  setInputStake,
  handleNotification,
  isZero,
  length,
}: OPERATION_PROPS) {
  const { minBet, maxBet, currency, precision } = gameInfo

  // const iconPadding = stake >= 0 && stake < 99.99 ? '0 0 0 25px' : '0 0 0 20px'
  // const inputPadding = stake >= 10 ? '0 0 0 10px' : '0px'

  return (
    <StakeWrapper textColor={colors.secondary}>
      <Button
        audio={audio}
        longPressEnabled
        borderColor={colors.secondary}
        textColor={colors.tertiary}
        background={colors.secondaryDark}
        func={(e?: boolean) => makeMathOperation(e ? 'minus' : e)}
        size='16px'
        SFX={SFX.divideSFX}
      >
        <MinusSVG />
      </Button>
      <InputBox
        radius='100px'
        width='160px'
        textcenter='center'
        fontsize='18px'
        // padding={iconPadding}
      >
        {/* <span> {Currencies[currency]}</span> */}
        <Input
          type='numbersDotComma'
          inputMode='decimal'
          width='160px'
          height='100%'
          size='14px'
          textcenter='center'
          maxLength={length || 100}
          data-testid='modal'
          innerBackground={stake > 0 ? colors.primaryLight : colors.primaryDark}
          focusColor={colors.primaryLight}
          borderColor={colors.secondary}
          radius='100px'
          number={stake}
          min={minBet}
          max={maxBet}
          setnumber={setnumber}
          setinputStake={setInputStake}
          currency={currency}
          handleNotification={handleNotification}
          isZero={isZero}
          toFix={precision}
          // padding={inputPadding}
        />
      </InputBox>
      <Button
        func={(e?: boolean) => makeMathOperation(e ? 'plus' : e)}
        longPressEnabled
        audio={audio}
        SFX={SFX.multiplySFX}
        borderColor={colors.secondary}
        textColor={colors.tertiary}
        background={colors.secondaryDark}
      >
        <PlusSVG />
      </Button>
    </StakeWrapper>
  )
}
